// extracted by mini-css-extract-plugin
module.exports = {"contract":"person_contract_1Dsbo","pic":"person_pic_1SVwO","editbtn":"person_editbtn_2HSlr"};